import React from "react";
import { CLASS_BOOKING } from "../../../assets/asset";

const PageContainer = ({ children, className = "", variant = "default" }) => {
  const isParentVariant = variant === "parent";

  return (
    <div
      className={`flex flex-col ${
        isParentVariant ? "font-mali bg-[#f8f3ea]" : "font-sans bg-blue-50"
      } relative min-h-screen w-full overflow-x-hidden ${className}`}
      style={
        isParentVariant
          ? undefined
          : {
              backgroundImage: `url(${CLASS_BOOKING.bg})`,
              backgroundSize: "cover",
              backgroundPosition: "center",
              backgroundRepeat: "no-repeat",
              backgroundAttachment: "fixed",
              WebkitBackgroundAttachment: "fixed",
            }
      }
    >
      {children}
    </div>
  );
};

export default PageContainer;
